import { render, staticRenderFns } from "./hightTrunkInfo.vue?vue&type=template&id=3b6f3608&scoped=true"
import script from "./hightTrunkInfo.vue?vue&type=script&lang=js"
export * from "./hightTrunkInfo.vue?vue&type=script&lang=js"
import style0 from "./hightTrunkInfo.vue?vue&type=style&index=0&id=3b6f3608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6f3608",
  null
  
)

export default component.exports